module.exports = __webpack_public_path__ + "img/paragraph-justified-align.6d3405e1.svg";